import {
  INIT_URL,
  SIGNOUT_USER_SUCCESS, 
  USER_TOKEN_SET,
  TYPE_USER_SET,
  USER_INFO_SET
} from "../constants/ActionTypes";

const INIT_STATE = {
  token: localStorage.getItem('mhc'),
  initURL: '',
  userType: -1,
  userInfo: {}

};

export default (state = INIT_STATE, action) => {
  switch (action.type) {


    case INIT_URL: {
      return {...state, initURL: action.payload};
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        userType: -1,
        initURL: ''
      }
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload,
      };
    }
    case TYPE_USER_SET: {
      return {
        ...state,
        userType: action.payload
      }
    }
    case USER_INFO_SET: {
      return {
        ...state,
        userInfo: action.payload
      }
    }

    default:
      return state;
  }
}
